import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";

interface PlanState {
  plans: any;
  planDetail:any;
  loading: boolean;
  error: string | null;
  getPlans: () => Promise<void>;
  getSinglePlans: (planId: number) => Promise<void>;
}

export const usePlanStore = create<PlanState>((set) => ({
  plans: null,
  planDetail: null,
  loading: false,
  error: null,

  getPlans: async () => {
    set({ loading: true, error: null });

    try {
      const response = await axiosInstance.get(`/getUserPlans`);
      set({ plans: response.data.rows });
    } catch (error: any) {
      console.error("Error fetching user plans:", error);
      set({ error: error.response?.data?.message || "Failed to fetch user plans" });
    } finally {
      set({ loading: false });
    }
  },
  getSinglePlans: async (planId) => {
    set({ loading: true, error: null });

    try {
      const response = await axiosInstance.post(`/getSinglePlan`,{planId});
      set({ planDetail: response.data });
    } catch (error: any) {
      console.error("Error fetching user plans:", error);
      set({ error: error.response?.data?.message || "Failed to fetch user plans" });
    } finally {
      set({ loading: false });
    }
  },
}));
